import ExpandIcon from "../../assets/ExpandIcon.svg";

export default function ExpandMoreIcon() {
  return <img src={ExpandIcon} alt="expand-arrow" />;
}
